
      import { Capacitor } from 'https://unpkg.com/@capacitor/core@latest/dist/index.js';
      window.Capacitor = Capacitor;
      window.isNativeApp = Capacitor.isNativePlatform();
      console.log('Running in native app:', window.isNativeApp);
      console.log('Platform:', Capacitor.getPlatform());
      
      // Prevent navigation to external sites
      if (window.isNativeApp) {
        document.addEventListener('DOMContentLoaded', function() {
          document.body.addEventListener('click', function(e) {
            const target = e.target.closest('a');
            if (target && target.href && target.href.startsWith('http')) {
              const url = new URL(target.href);
              const currentUrl = new URL(window.location.href);
              
              // If it's an external link, prevent it
              if (url.hostname !== currentUrl.hostname) {
                e.preventDefault();
                console.log('Prevented navigation to external site:', target.href);
              }
            }
          });
        });
      }
      
      // Apply CSS variables based on theme
      document.addEventListener('DOMContentLoaded', function() {
        // Define the CSS variables for both light and dark modes
        const setCSSVariables = () => {
          const isDarkMode = document.documentElement.classList.contains('dark');
          const isDarkroomMode = document.body.classList.contains('darkroom-mode');
          
          if (isDarkroomMode) {
            document.documentElement.style.setProperty('--background', 'black');
            document.documentElement.style.setProperty('--background-dark', 'black');
          } else if (isDarkMode) {
            // Dark theme values from CSS
            document.documentElement.style.setProperty('--background', 'hsl(0 0% 12%)');
            document.documentElement.style.setProperty('--background-dark', 'hsl(0 0% 12%)');
          } else {
            // Light theme values from CSS
            document.documentElement.style.setProperty('--background', 'hsl(0 0% 98%)');
            document.documentElement.style.setProperty('--background-dark', 'hsl(0 0% 12%)');
          }
        };
        
        // Initial setting
        setCSSVariables();
        
        // Watch for theme changes
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.attributeName === 'class') {
              setCSSVariables();
            }
          });
        });
        
        observer.observe(document.documentElement, { attributes: true });
        observer.observe(document.body, { attributes: true });
      });
    